import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/admin/verify-token`
export const LOGIN_URL = `${API_URL}/admin/login`
export const REGISTER_URL = `${API_URL}/register`
export const GET_USER_PERMISSIONS = `${API_URL}/admin-permissions/`
export const FORGET_PASSWORD_URL = `${API_URL}/admin/forget-password`
export const RESET_PASSWORD_URL = `${API_URL}/admin/reset-password`
// all permissions of logged in user
export const get_user_permissions = async () => {
  let response = await axios.get(`${API_URL}/admin-permissions`);
  return response.data;
}
// Server should return AuthModel
export async function login(email: string, password: string) {
  const response = await axios.post(LOGIN_URL, {
    email,
    password,
  })
  return response?.data
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(FORGET_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}
export async function resetPassword(token: string, email: string, password: string, password_confirmation: string,) {
  const response = await axios.post<{result: boolean}>(RESET_PASSWORD_URL, {
    email,
    password,
    password_confirmation,
    token,
  })
  return response?.data
}
// Sign Out
export function signout(api_token: string) {
  const headers = {
    Authorization: `Bearer ${api_token}`,
  };
    return axios.post(`${API_URL}/admin/logout`, {}, { headers });
}